import { createSlice } from '@reduxjs/toolkit';

export const reducerName = 'frontpageState';

const initialState = {
    activeFrontpage: 0,
};

const frontpageSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setActiveFrontpage: (state, action) => {
            state.activeFrontpage = action.payload !== 0
                ? state.activeFrontpage + action.payload
                : 0;
        },
    },
});

export const { setActiveFrontpage } = frontpageSlice.actions;
export default frontpageSlice.reducer;